import { Navigate } from "react-router-dom";
import { useAuth } from "../Services/AuthContext";

interface ProtectedRouteProps {
    children: React.ReactNode;
    roles?:string[]
}

const ProtectedRoute = ({ children,roles }: ProtectedRouteProps) => {
   const {user,isLoading}=useAuth();
   if(isLoading){
    return <div>Loading</div>
   }

   if(!user){
        return <Navigate to="/login" replace />;
   }
   if(roles && !user.roles.some(r=>roles.includes(r))) {
       return <Navigate to="/" replace />;
   }
    
    return <>{children}</>;
}
export default ProtectedRoute;